import 'simplebar';
import 'simplebar/dist/simplebar.css';
import ResizeObserver from 'resize-observer-polyfill';
window.ResizeObserver = ResizeObserver;

const params = new URLSearchParams(window.location.search);

const eventModalCache = {};

const fetchEventModal = async (eventID) => {
	try {
		const response = await fetch(
			`/wp-json/propel/v1/events/modal/${eventID}`,
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			}
		);

		const data = await response.json();
		const modalHTML = data?.modal;

		if (!modalHTML) {
			throw new Error('No event modal HTML returned from server');
		}

		return modalHTML;
	} catch (error) {
		console.error('Error fetching event details:', error); // eslint-disable-line no-console
	}
};

// Prefetch event modal on "View Details" button hover.
document.addEventListener('mouseover', async (e) => {
	if (!e.target.closest('.event-card__view-details')) {
		return;
	}

	const eventCard = e.target.closest('.event-card');

	if (!eventCard) {
		return;
	}

	const eventID = eventCard.getAttribute('data-event-id');

	if (eventModalCache[eventID]) {
		return;
	}

	const modalHTML = await fetchEventModal(eventID);

	if (modalHTML) {
		eventModalCache[eventID] = modalHTML;
	}
});

document.addEventListener('click', async (e) => {
	if (
		!e.target.closest('.event-card__view-details') ||
		e.target.dataset.triggerModal !== 'true'
	) {
		return;
	}

	e.preventDefault();

	openModal(null, e);
});

const openModal = async (eventID, e) => {
	if (!eventID) {
		const eventCard = e.target.closest('.event-card');

		if (!eventCard) {
			return;
		}

		eventID = eventCard.getAttribute('data-event-id');
	}
	let modalHTML = eventModalCache[eventID] ?? null;

	// Launch modal with loading state.
	const modalContainer = document.createElement('div');
	// Skeleton html.
	modalContainer.innerHTML = `
	<div class="event-modal event-modal--loading">
		<div class="wp-block-button event-modal__close wp-block-button--icon-right is-style-tertiary" style="--buttonIcon: var(--icon-close);">
			<a href="#" class="wp-block-button__link">Close</a>
		</div>

		<div class="event-modal__inner">
			<div class="event-modal__top">
				<div class="event-modal__sidebar"></div>
				<div class="event-modal__content"></div>
			</div>
		</div>

		<div class="event-modal__sessions"></div>
	</div>
	`;
	modalContainer.classList.add('event-modal-container');
	document.body.appendChild(modalContainer);
	document.body.classList.add('event-modal-active');

	if (!modalHTML) {
		modalHTML = await fetchEventModal(eventID);

		if (modalHTML) {
			eventModalCache[eventID] = modalHTML;
		}
	}

	if (!eventModalCache[eventID]) {
		return;
	}

	modalContainer.innerHTML = eventModalCache[eventID];
	modalContainer
		.querySelector('.event-modal')
		?.classList.remove('event-modal--loading');
};

const closeModal = (modal) => {
	if (!modal) {
		return;
	}

	modal.remove();
	document.body.classList.remove('event-modal-active');
};

if (params.get('p_event_modal')) {
	openModal(params.get('p_event_modal'));
}

// Close event modal on close button click.
document.addEventListener('click', (e) => {
	if (!e.target.closest('.event-modal__close')) {
		return;
	}

	e.preventDefault();

	const modal = e.target.closest('.event-modal-container');

	closeModal(modal);
});

// Close event modal on "esc" key press.
document.addEventListener('keydown', (e) => {
	if (e.key !== 'Escape') {
		return;
	}

	const modal = document.querySelector('.event-modal-container');

	closeModal(modal);
});
